import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  "data-tour": "store-availability",
  class: "max-w-[1040px]"
}
const _hoisted_2 = { class: "-m-2 flex gap-2 overflow-x-auto p-2" }
const _hoisted_3 = { class: "flex items-center sm:h-10 w-full" }
const _hoisted_4 = { class: "sm:flex sm:items-center grow min-w-0 mr-2 sm:mr-0" }
const _hoisted_5 = { class: "sm:w-96 truncate mb-1 sm:mb-0" }
const _hoisted_6 = { class: "max-w-xs overflow-x-auto overflow-y-hidden flex space-x-1" }
const _hoisted_7 = { class: "w-full h-1/2 text-sm font-semibold tracking-tight" }
const _hoisted_8 = { class: "w-full h-1/2 text-xxs border-t" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "bg-gray-100 rounded-md px-2 h-10 w-20 text-center shrink-0" }
const _hoisted_14 = { class: "w-full h-1/2 text-sm font-semibold tracking-tight" }
const _hoisted_15 = {
  key: 0,
  class: "w-full h-1/2 text-xxs border-t"
}
const _hoisted_16 = {
  key: 1,
  class: "w-full h-1/2 text-xxs border-t"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "bg-yellow-100 rounded-md px-2 h-10 w-20 text-center shrink-0"
}
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "flex space-x-4 flex-1" }
const _hoisted_25 = { class: "text-left text-gray-700" }
const _hoisted_26 = { class: "text-sm font-medium leading-none" }
const _hoisted_27 = { class: "text-sm text-gray-500" }
const _hoisted_28 = { class: "text-xs text-gray-500" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mb-8" }
const _hoisted_31 = {
  key: 0,
  class: "w-8 h-8 mr-2"
}
const _hoisted_32 = { class: "aspect-w-8 aspect-h-8" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "flex-1 min-w-0" }
const _hoisted_35 = { class: "text-left transition-colors duration-150 text-gray-700 hover:text-blue-600" }
const _hoisted_36 = { class: "text-md font-medium truncate" }
const _hoisted_37 = { class: "text-sm text-gray-700" }
const _hoisted_38 = { class: "flex flex-wrap items-center justify-start mt-2" }
const _hoisted_39 = { class: "text-sm font-medium max-w-xs truncate" }
const _hoisted_40 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_41 = { class: "text-sm font-medium max-w-xs truncate" }
const _hoisted_42 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "flex justify-end mt-2" }
const _hoisted_45 = {
  key: 1,
  class: "text-sm text-gray-500 mt-1"
}
const _hoisted_46 = { class: "space-y-3" }
const _hoisted_47 = { class: "flex items-center gap-4" }
const _hoisted_48 = { class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-indigo-100" }
const _hoisted_49 = { class: "min-w-0 flex-grow" }
const _hoisted_50 = { class: "truncate text-base font-semibold text-gray-900" }
const _hoisted_51 = { class: "flex flex-col items-end justify-between gap-3 self-stretch border-l border-gray-200 pl-4" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 0,
  class: "mt-4 border-t border-gray-100 pt-4"
}
const _hoisted_54 = { class: "text-sm text-gray-700" }
const _hoisted_55 = { class: "font-semibold" }

import { CheckIcon, XMarkIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon, CalendarDaysIcon, LockClosedIcon, XCircleIcon } from '@heroicons/vue/24/outline'
import Sortable from 'sortablejs'
import { Calendar } from 'v-calendar'
import { computed, onMounted, ref, watch } from 'vue'

import FranchiseLockNotice from '@/components/franchise/FranchiseLockNotice.vue'
import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import NeueToggle from '@/components/neue/NeueToggle'
import ProductSearchPicker from '@/components/neue/ProductSearchPicker'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import { orderedPairsPayload, renumberOrder, reorderVisibleSubset } from '@/composables/reorderVisibleSubset'
import { dateObjectToServerDay, serverDayToDateObject } from '@/helpers/dates'
import {
  FRANCHISE_EDITABLE_PAIR_KEYS,
  franchiseEditable,
  franchiseLockText,
  isFranchiseManaged
} from '@/helpers/franchiseManaged'
import { pairMembershipPriceRows } from '@/helpers/membershipPrices'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreAvailability',
  props: ['id'],
  setup(__props) {

const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const isCateringStore = computed(() => store.value?.attributes?.platform === 'catering')
const productLink = id => (isCateringStore.value ? `/store/stores/${props.id}/products/${id}` : `/store/products/${id}`)
const productAvailabilityData = ref([])
const addModal = ref({ open: false })
const pairModal = ref({ open: false })
const removeModal = ref({ open: false, pair: null, loading: false })
// Days the merchant has clicked but not yet saved (array of 'YYYY-MM-DD' strings).
const pendingDays = ref([])
const groups = ref({})
const filter = ref(null)
const reorderingPairs = ref(false)

watch(
  () => Object.keys(groups.value).length,
  () => {
    for (const [categoryId, group] of Object.entries(groups.value)) {
      new Sortable(group, {
        handle: '.cursor-move',
        ghostClass: 'bg-gray-200',
        dragClass: 'bg-white',
        onSort: async () => {
          reorderingPairs.value = true

          const category = categories.value.find(cat => cat.id === categoryId)
          if (!category) {
            console.error('Category not found:', categoryId)
            reorderingPairs.value = false
            return
          }

          const list = pairs(category)

          if (!list || list.length === 0) {
            console.error('No products found in category')
            reorderingPairs.value = false
            return
          }

          // Sortable has already moved the row, so the DOM holds the new order of the rows
          // currently on screen - only a subset of the category when a day is filtered on.
          const visibleIds = Array.from(group.children).map(row => parseInt(row.getAttribute('data-product-id')))
          const orderedProducts = renumberOrder(reorderVisibleSubset(list, visibleIds))

          category.attributes.products = orderedProducts

          try {
            const validPairs = orderedPairsPayload(orderedProducts)

            await api.call('PUT', `stores/${props.id}/categories/${categoryId}`, {
              category: {
                category_product_store_pairs_attributes: validPairs
              }
            })
          } catch (error) {
            console.error('Error reordering products:', error)
            // The new order is already on screen, so fall back to what actually saved
            // rather than leaving the merchant looking at an order that does not exist.
            await loadProductAvailability()
          } finally {
            reorderingPairs.value = false
          }
        }
      })
    }
  }
)

const loadProductAvailability = async () => {
  try {
    const response = await api.call('GET', `stores/${props.id}/product_availability`)
    productAvailabilityData.value = response.data.data || []
  } catch (error) {
    console.error('Error fetching product availability:', error)
    productAvailabilityData.value = []
  }
}

onMounted(async () => {
  await loadProductAvailability()
  loading.value = false
})

const formatDay = day => {
  const date = day.attributes?.date || day.date
  return new Intl.DateTimeFormat([], { dateStyle: 'full' }).format(serverDayToDateObject(date))
}
const shortFormatDay = day => {
  const date = day.attributes?.date || day.date
  return new Intl.DateTimeFormat(['en-CA'], { month: 'short', day: 'numeric' }).format(serverDayToDateObject(date))
}
const categories = computed(() =>
  (productAvailabilityData.value || [])
    .filter(x => x.attributes.category_name !== 'Upsells Category')
    .sort((a, b) => a.attributes.order_value - b.attributes.order_value)
)
const pairs = category => (category.attributes.products || []).sort((a, b) => (a.order || 0) - (b.order || 0))
// The availability rows carry only the flag; the franchise is named on the categories.
const availabilityFranchiseName = computed(
  () => productAvailabilityData.value.find(category => category.attributes.franchise_name)?.attributes.franchise_name
)

const pairsWithProducts = category => pairs(category)

// The rows actually rendered for a category: everything when no day is filtered on,
// otherwise the pairs available on that day.
const visiblePairs = category =>
  pairsWithProducts(category).filter(pair =>
    filter.value
      ? currentAvailabilityDays(pair).some(day => day.date === filter.value) ||
        (pair.fulfillment_availabilities &&
          pair.fulfillment_availabilities.length === 0 &&
          pair.available_for_all_fulfillment_availabilities)
      : true
  )

const product = pair => pair
const availabilityDays = pair => {
  if (pair.fulfillment_availabilities) {
    return pair.fulfillment_availabilities || []
  } else if (pair.relationships && pair.relationships.fulfillment_availabilities) {
    return mapRelationships(pair.relationships.fulfillment_availabilities.data) || []
  }
  return []
}
const currentAvailabilityDays = pair => {
  const yesterday = new Date().setDate(new Date().getDate() - 1)
  return availabilityDays(pair)
    .filter(x => {
      const date = x.date
      return serverDayToDateObject(date) > yesterday
    })
    .sort((a, b) => {
      const dateA = serverDayToDateObject(a.date)
      const dateB = serverDayToDateObject(b.date)
      return dateA - dateB
    })
}
const hasCustomPrices = pair => pair.has_custom_prices || false

const slots = ref([])
const date = new Date()
const from = dateObjectToServerDay(date)
date.setDate(date.getDate() + 7 * 8)
const to = dateObjectToServerDay(date)
api.call('GET', `fulfillment_slots?date_from=${from}&date_to=${to}&included=none`).then(x => {
  slots.value = x.data.data
})
const methodActive = method => {
  const pairs = mapRelationships(store.value?.relationships?.fulfillment_method_store_pairs?.data)
  return pairs.some(x => x.attributes.fulfillment_method_id.toString() === method.id)
}
const slotDays = computed(() =>
  slots.value
    .filter(
      x =>
        x.relationships?.fulfillment_method?.data?.id &&
        methodActive({ id: x.relationships.fulfillment_method.data.id })
    )
    .map(y => y.attributes.fulfillment_date)
)

// Only days with an available fulfillment slot (within the next 8 weeks) may be
// selected for product availability, mirroring the drop calendar's behaviour.
const startOfDay = d => {
  const x = new Date(d)
  x.setHours(0, 0, 0, 0)
  return x
}

const maxSelectableDate = computed(() => {
  const d = startOfDay(new Date())
  d.setDate(d.getDate() + 7 * 8)
  return d
})

const availableSlotDayTimes = computed(() => {
  const times = new Set()
  for (const day of slotDays.value) {
    const date = serverDayToDateObject(day)
    if (date) times.add(date.getTime())
  }
  return times
})

const datePickerDisabledDates = computed(() => {
  const disabled = []
  const cursor = startOfDay(new Date())
  for (let i = 0; i <= 7 * 8; i++) {
    if (!availableSlotDayTimes.value.has(cursor.getTime())) disabled.push(new Date(cursor))
    cursor.setDate(cursor.getDate() + 1)
  }
  return disabled
})

const filterableDays = computed(() => {
  const availDays = categories.value
    .flatMap(x => pairs(x))
    .flatMap(x => currentAvailabilityDays(x))
    .map(x => x.date)
  return [...new Set(availDays.concat(slotDays.value))].sort()
})

const addProducts = category => {
  addModal.value = {
    open: true,
    category,
    selectedProducts: []
  }
}

const saveAddModal = async () => {
  try {
    for (const product of addModal.value.selectedProducts) {
      const existingPair = pairs(addModal.value.category).find(x => x.product_id == product.id)
      if (existingPair && filter.value) {
        await api.call(
          'PUT',
          `stores/${props.id}/category_product_store_pairs/${existingPair.id}?included=fulfillment_availabilities`,
          {
            category_product_store_pair: {
              fulfillment_availabilities_attributes: [{ date: filter.value }]
            }
          }
        )
      } else {
        await api.call('POST', `stores/${props.id}/category_product_store_pairs`, {
          category_product_store_pair: {
            category_id: addModal.value.category.id,
            product_id: product.id,
            ...(filter.value && {
              available_for_all_fulfillment_availabilities: false,
              fulfillment_availabilities_attributes: [{ date: filter.value }]
            })
          }
        })
      }
    }
    addModal.value.open = false
    await loadProductAvailability()
  } catch (error) {
    console.error('Error adding products:', error)
  }
}

// Highlight saved days (solid) and pending-but-unsaved days (light) on the calendar,
// and show a hover tooltip on unavailable days explaining why they can't be selected.
const calendarAttributes = computed(() => {
  if (!pairModal.value.pair) return []
  const savedDates = availabilityDays(pairModal.value.pair)
    .map(d => serverDayToDateObject(d.attributes?.date || d.date))
    .filter(Boolean)
  const pendingDates = pendingDays.value.map(serverDayToDateObject).filter(Boolean)
  return [
    { key: 'saved', highlight: { color: 'gray', fillMode: 'solid' }, dates: savedDates },
    { key: 'pending', highlight: { color: 'blue', fillMode: 'light' }, dates: pendingDates },
    {
      key: 'unavailable',
      dates: datePickerDisabledDates.value,
      popover: {
        label: 'No fulfillment slots for this date',
        visibility: 'hover',
        hideIndicator: true
      }
    }
  ]
})

const onDayClick = day => {
  if (!pairModal.value.pair || pairModal.value.managed) return
  if (day.isDisabled) return
  const serverDay = dateObjectToServerDay(day.startDate)
  // Already saved -> delete it (existing confirm + API flow).
  const existing = availabilityDays(pairModal.value.pair).find(d => (d.attributes?.date || d.date) === serverDay)
  if (existing) {
    deleteDay(existing)
    return
  }
  // Otherwise toggle it in the pending selection.
  const idx = pendingDays.value.indexOf(serverDay)
  if (idx === -1) pendingDays.value.push(serverDay)
  else pendingDays.value.splice(idx, 1)
}

const addDays = async () => {
  if (!pendingDays.value.length || pairModal.value.managed) return
  for (const serverDay of pendingDays.value) {
    try {
      await api.call(
        'PUT',
        `stores/${props.id}/category_product_store_pairs/${pairModal.value.pair.id}?included=fulfillment_availabilities`,
        {
          category_product_store_pair: {
            fulfillment_availabilities_attributes: [{ date: serverDay }]
          }
        }
      )
    } catch (error) {
      console.error(`Error adding day ${serverDay}:`, error)
    }
  }
  pairModal.value.pair = mapRelationship({ type: 'category_product_store_pair', id: pairModal.value.pair.id })
  pendingDays.value = []
  await loadProductAvailability()
}

const deleteDay = async day => {
  if (pairModal.value.managed) return
  if (!confirm(`Delete ${formatDay(day)}?`)) return
  try {
    await api.call('PUT', `stores/${store.value.id}/category_product_store_pairs/${pairModal.value.pair.id}`, {
      category_product_store_pair: { fulfillment_availabilities_attributes: [{ id: day.id, _destroy: true }] }
    })
    pairModal.value.pair = mapRelationship({ type: 'category_product_store_pair', id: pairModal.value.pair.id })
    await loadProductAvailability()
  } catch (error) {
    console.error('Error deleting day:', error)
  }
}

const editPair = async pair => {
  try {
    const includes = [
      'product.attachments',
      'product.labels',
      'product.replace_with_product',
      'product.replaces_products',
      'fulfillment_availabilities',
      'product_store_membership_prices.membership_tier'
    ]
    const response = await api.call(
      'GET',
      `stores/${props.id}/category_product_store_pairs/${pair.id}?included=${includes.join(',')}`
    )
    const detailedPair = response.data.data

    pairModal.value = {
      open: true,
      pair: detailedPair,
      // The row knows the flag even when the detail response is serialized without it.
      managed: isFranchiseManaged(detailedPair) || isFranchiseManaged(pair),
      franchiseName: detailedPair.attributes.franchise_name ?? availabilityFranchiseName.value ?? null,

      product: mapRelationship(detailedPair.relationships.product.data),
      image: mapRelationship(detailedPair.relationships.product.data)
        ? mapRelationships(mapRelationship(detailedPair.relationships.product.data).relationships.attachments.data)[0]
            ?.attributes.secure_url || null
        : null,
      labels: mapRelationship(detailedPair.relationships.product.data)
        ? mapRelationships(mapRelationship(detailedPair.relationships.product.data).relationships.labels.data)
        : [],

      taxable: detailedPair.attributes.taxable,
      allowsAutofill: detailedPair.attributes.allows_autofill,
      showPrice: detailedPair.attributes.show_prices,
      productCardStyle: detailedPair.attributes.product_card_style,
      quantityDisplay: detailedPair.attributes.quantity_selector_type,

      fallback: mapRelationship(detailedPair.relationships.product.data)
        ? mapRelationship(
            mapRelationship(detailedPair.relationships.product.data).relationships.replace_with_product.data
          )
        : null,
      reverseFallback: mapRelationship(detailedPair.relationships.product.data)
        ? mapRelationships(
            mapRelationship(detailedPair.relationships.product.data).relationships.replaces_products.data
          )
        : [],

      alwaysAvailable: detailedPair.attributes.available_for_all_fulfillment_availabilities,
      hasInventoryLimit: Object.fromEntries(
        mapRelationships(detailedPair.relationships.fulfillment_availabilities.data).map(x => [
          x.id,
          x.attributes.limit_quantity
        ])
      ),
      inventoryLimit: Object.fromEntries(
        mapRelationships(detailedPair.relationships.fulfillment_availabilities.data).map(x => [
          x.id,
          x.attributes.quantity_limit
        ])
      ),

      productHasQuantityLimit:
        mapRelationship(detailedPair.relationships.product.data)?.attributes.has_quantity_limit || false,
      productInventoryLimit:
        mapRelationship(detailedPair.relationships.product.data)?.attributes.inventory_remaining ?? null,

      membershipPrices: pairMembershipPriceRows(detailedPair)
    }
    pendingDays.value = []
  } catch (error) {
    console.error('Error fetching product details:', error)
  }
}

// On a managed pair only the product's overall inventory is the franchisee's; the API drops the rest.
const pairUpdate = attributes =>
  pairModal.value.managed ? franchiseEditable(attributes, FRANCHISE_EDITABLE_PAIR_KEYS) : attributes

const savePairModal = async () => {
  try {
    await api.call(
      'PUT',
      `stores/${props.id}/category_product_store_pairs/${pairModal.value.pair.id}?included=fulfillment_availabilities,product_store_membership_prices`,
      {
        category_product_store_pair: pairUpdate({
          taxable: pairModal.value.taxable,
          allows_autofill: pairModal.value.allowsAutofill,
          show_prices: pairModal.value.showPrice,
          product_card_style: pairModal.value.productCardStyle,
          quantity_selector_type: pairModal.value.quantityDisplay,
          available_for_all_fulfillment_availabilities: pairModal.value.alwaysAvailable,
          product_store_membership_prices_attributes: pairModal.value.membershipPrices.map(x => ({
            id: x.priceId,
            membership_tier_id: x.tierId,
            price_cents: Math.round(x.price * 100),
            subject_to_pricing_tiers: x.subject,
            available_for_membership_tier: x.available,
            use_default_price: x.default
          })),
          fulfillment_availabilities_attributes: mapRelationships(
            pairModal.value.pair.relationships.fulfillment_availabilities.data
          ).map(x => ({
            id: x.id,
            quantity_limit: pairModal.value.inventoryLimit[x.id],
            limit_quantity: pairModal.value.hasInventoryLimit[x.id]
          })),
          product_attributes: {
            id: pairModal.value.product.id,
            has_quantity_limit: pairModal.value.productHasQuantityLimit,
            ...(pairModal.value.productHasQuantityLimit && {
              set_quantity_changes_attributes: [{ value: pairModal.value.productInventoryLimit }]
            })
          }
        })
      }
    )

    // Switching to "Always available" deletes the dated availabilities server side,
    // so re-read the pair before the next save or it would send ids that no longer exist.
    pairModal.value.pair =
      mapRelationship({ type: 'category_product_store_pair', id: pairModal.value.pair.id }) ?? pairModal.value.pair
    await loadProductAvailability()
  } catch (error) {
    console.error('Error saving product details:', error)
  }
}

const closePairModal = () => {
  pairModal.value.open = false
  pendingDays.value = []
}

const askRemovePair = pair => {
  if (isFranchiseManaged(pair)) return
  removeModal.value = { open: true, pair, loading: false }
}

const confirmRemovePair = async () => {
  const pair = removeModal.value.pair
  if (!pair || removeModal.value.loading) return
  removeModal.value.loading = true
  try {
    await api.call('DELETE', `stores/${props.id}/category_product_store_pairs/${pair.id}`, {}, { delete: false })
    await loadProductAvailability()
    removeModal.value = { open: false, pair: null, loading: false }
  } catch (error) {
    console.error('Error deleting product:', error)
    removeModal.value.loading = false
  }
}

return (_ctx, _cache) => {
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Products",
            description: "Every product this store sells, grouped by category. Click a product to schedule the days it is available and set inventory limits.",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(NeueButton), {
                  type: !filter.value ? 'primary' : 'secondary',
                  onClick: _cache[0] || (_cache[0] = $event => (filter.value = null))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("All", -1)
                  ]))]),
                  _: 1
                }, 8, ["type"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterableDays.value, (day) => {
                  return (_openBlock(), _createBlock(_unref(NeueButton), {
                    type: filter.value === day ? 'primary' : 'secondary',
                    onClick: $event => (filter.value = day)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat(['en-CA'], { month: 'short', day: 'numeric' }).format(_unref(serverDayToDateObject)(day))), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"]))
                }), 256))
              ]),
              _withDirectives(_createVNode(_unref(NeueTablist), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: category.id
                    }, [
                      _createVNode(_unref(TablistHeader), null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(category.attributes.category_name), 1),
                          _createVNode(_unref(NeueButton), {
                            type: "secondary",
                            onClick: $event => (addProducts(category))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" + Products " + _toDisplayString(filter.value
                    ? `for ${new Intl.DateTimeFormat(['en-CA'], { month: 'short', day: 'numeric' }).format(
                        _unref(serverDayToDateObject)(filter.value)
                      )}`
                    : ''), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      (pairsWithProducts(category).length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_for: true,
                            ref: el => (groups.value[category.id] = el),
                            class: "divide-y divide-gray-200"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePairs(category), (pair) => {
                              return (_openBlock(), _createBlock(_unref(TablistRow), {
                                key: pair.id,
                                "data-product-id": pair.id,
                                class: "cursor-pointer",
                                onClick: $event => (editPair(pair))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["-ml-4 px-3 py-5", _unref(isFranchiseManaged)(pair) ? 'invisible' : reorderingPairs.value ? 'cursor-wait' : 'cursor-move']),
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                    ], 2),
                                    _createElementVNode("div", _hoisted_4, [
                                      _createElementVNode("div", _hoisted_5, _toDisplayString(product(pair)?.product_name), 1),
                                      _createElementVNode("div", _hoisted_6, [
                                        (!currentAvailabilityDays(pair).length && pair.fulfillment_availabilities.length === 0)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass([pair.available_for_all_fulfillment_availabilities ? 'bg-gray-100' : 'bg-yellow-100', "rounded-md px-2 h-10 w-20 text-center shrink-0"])
                                            }, [
                                              _createElementVNode("div", _hoisted_7, _toDisplayString(pair.available_for_all_fulfillment_availabilities ? 'Always' : 'No days'), 1),
                                              _createElementVNode("div", _hoisted_8, [
                                                (pair.available_for_all_fulfillment_availabilities)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                      (pair.product_has_inventory_limit)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(pair.product_inventory_remaining) + " remaining ", 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "∞ remaining"))
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "Unavailable"))
                                              ])
                                            ], 2))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentAvailabilityDays(pair), (day) => {
                                          return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, _toDisplayString(shortFormatDay(day)), 1),
                                            (day.limit_quantity)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Limit of " + _toDisplayString(day.quantity_limit), 1))
                                              : _createCommentVNode("", true),
                                            (!day.limit_quantity)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                  (pair.product_has_inventory_limit)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(pair.product_inventory_remaining) + " remaining ", 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_18, "No limit"))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 256)),
                                        (pair.fulfillment_availabilities.length > 0 && !currentAvailabilityDays(pair).length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[18] || (_cache[18] = [
                                              _createElementVNode("div", { class: "w-full h-1/2 text-sm font-semibold tracking-tight" }, "No days", -1),
                                              _createElementVNode("div", { class: "w-full h-1/2 text-xxs border-t" }, "Unavailable", -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createTextVNode(_toDisplayString(product(pair)?.price) + _toDisplayString(hasCustomPrices(pair) ? '*' : ''), 1)
                                    ])), [
                                      [_directive_tippy, {
                      content: hasCustomPrices(pair)
                        ? 'Default price (some membership tiers use a different price)'
                        : 'Default price'
                    }]
                                    ]),
                                    (_unref(isFranchiseManaged)(pair))
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          "data-test": "pair-lock",
                                          class: "sm:ml-4 ml-1 shrink-0 sm:mr-0 -mr-2",
                                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                        }, [
                                          _createVNode(_unref(LockClosedIcon), { class: "h-6 w-6 text-gray-400" })
                                        ])), [
                                          [_directive_tippy, { content: _unref(franchiseLockText)(availabilityFranchiseName.value) }]
                                        ])
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          "data-test": "remove-pair",
                                          class: "sm:ml-4 ml-1 shrink-0 sm:mr-0 -mr-2",
                                          onClick: _withModifiers($event => (askRemovePair(pair)), ["stop"])
                                        }, [
                                          _createVNode(_unref(XCircleIcon), { class: "cursor-pointer h-6 w-6 hover:text-black" })
                                        ], 8, _hoisted_21))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["data-product-id", "onClick"]))
                            }), 128))
                          ], 512))
                        : _createCommentVNode("", true),
                      (!pairs(category).length)
                        ? (_openBlock(), _createBlock(_unref(TablistRow), {
                            key: 1,
                            class: "justify-around"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(EmptyState), {
                                plural: "products",
                                class: "mt-1 mb-2"
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 512), [
                [_vShow, categories.value.length]
              ]),
              (!categories.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_unref(EmptyState), { plural: "categories" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_TheModal, {
      "is-open": addModal.value.open,
      "modal-title": "Add products",
      "modal-description": `Select products for ${addModal.value.category?.attributes.category_name}`,
      onCloseModal: _cache[5] || (_cache[5] = $event => (addModal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(ProductSearchPicker), {
          modelValue: addModal.value.selectedProducts,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((addModal.value.selectedProducts) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addModal.value.selectedProducts, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: "group py-2 mt-2 px-2 duration-150 transition-colors hover:bg-gray-100"
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(CheckIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" }),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(item.attributes.product_name), 1),
                    _createElementVNode("p", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(item.attributes.description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _withModifiers($event => (addModal.value.selectedProducts = addModal.value.selectedProducts.filter(x => x.id !== item.id)), ["prevent"])
                }, [
                  _createVNode(_unref(XMarkIcon), { class: "w-4 h-4 rounded-full mr-2 text-gray-700" })
                ], 8, _hoisted_29)
              ])
            ]))
          }), 128))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[4] || (_cache[4] = $event => (addModal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: addModal.value.selectedProducts.length ? 'primary' : 'inactive',
          onClick: saveAddModal
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode(" Save ", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open", "modal-description"]),
    _createVNode(_component_TheModal, {
      "is-open": pairModal.value.open,
      "modal-title": "Edit product",
      onCloseModal: _cache[14] || (_cache[14] = $event => (pairModal.value.open = false))
    }, {
      main: _withCtx(() => [
        (pairModal.value.managed)
          ? (_openBlock(), _createBlock(FranchiseLockNotice, {
              key: 0,
              "franchise-name": pairModal.value.franchiseName
            }, null, 8, ["franchise-name"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_router_link, {
            to: productLink(pairModal.value.product.id),
            class: "flex items-center",
            target: isCateringStore.value ? null : '_blank'
          }, {
            default: _withCtx(() => [
              (pairModal.value.image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("img", {
                        class: "w-full h-full object-center object-cover rounded select-none",
                        src: pairModal.value.image
                      }, null, 8, _hoisted_33)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, _toDisplayString(pairModal.value.product.attributes.product_name), 1),
                  _createElementVNode("p", _hoisted_37, _toDisplayString(pairModal.value.product.attributes.description), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["to", "target"]),
          _createElementVNode("div", _hoisted_38, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairModal.value.labels, (label) => {
              return (_openBlock(), _createElementBlock("span", {
                key: label.id,
                class: "mr-1 mb-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
              }, _toDisplayString(label.attributes.label_name), 1))
            }), 128))
          ])
        ]),
        _createVNode(_unref(FormSection), { name: "Settings" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: pairModal.value.taxable,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((pairModal.value.taxable) = $event)),
                  name: "Taxable",
                  disabled: pairModal.value.managed,
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: pairModal.value.allowsAutofill,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((pairModal.value.allowsAutofill) = $event)),
                  name: "Include item in logic when autofilling orders",
                  disabled: pairModal.value.managed,
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: pairModal.value.showPrice,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((pairModal.value.showPrice) = $event)),
                  name: "Show price",
                  disabled: pairModal.value.managed,
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectInput, {
                  modelValue: pairModal.value.productCardStyle,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((pairModal.value.productCardStyle) = $event)),
                  name: "Product card style",
                  disabled: pairModal.value.managed,
                  options: [
              { name: 'Image upper right corner', value: 'default' },
              { name: 'Full-bleed image', value: 'enlarged-image' }
            ],
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectInput, {
                  modelValue: pairModal.value.quantityDisplay,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((pairModal.value.quantityDisplay) = $event)),
                  name: "Quantity display type",
                  disabled: pairModal.value.managed,
                  options: [
              { name: 'Default', value: 'default' },
              { name: 'Checkbox', value: 'checkbox' }
            ],
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(FormSection), { name: "Autofill replacement" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm" }, "Fallback product if this product is unavailable during autofill:", -1)),
                (pairModal.value.fallback)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "text-gray-900 hover:text-blue-600 transition-colors duration-150 text-left p-2 block",
                      to: '/store/products/' + pairModal.value.fallback.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_39, _toDisplayString(pairModal.value.fallback.attributes.product_name), 1),
                        _withDirectives(_createElementVNode("p", { class: "text-sm text-gray-500 max-w-sm truncate" }, _toDisplayString(pairModal.value.fallback.attributes.description), 513), [
                          [_vShow, pairModal.value.fallback.attributes.description]
                        ])
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, "None"))
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-sm" }, "Will replace these unavailable products during autofill:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairModal.value.reverseFallback, (product) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: product.id,
                    class: "text-gray-900 hover:text-blue-600 transition-colors duration-150 text-left p-2 block",
                    to: '/store/products/' + product.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_41, _toDisplayString(product.attributes.product_name), 1),
                      _withDirectives(_createElementVNode("p", { class: "text-sm text-gray-500 max-w-sm truncate" }, _toDisplayString(product.attributes.description), 513), [
                        [_vShow, product.attributes.description]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128)),
                (!pairModal.value.reverseFallback.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "None"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(FormSection), { name: "Production day availability" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: pairModal.value.alwaysAvailable,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((pairModal.value.alwaysAvailable) = $event)),
                  name: "Always available",
                  disabled: pairModal.value.managed,
                  onChange: savePairModal
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (!pairModal.value.alwaysAvailable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!pairModal.value.managed)
                    ? (_openBlock(), _createBlock(_unref(FormElement), {
                        key: 0,
                        "data-test": "day-picker"
                      }, {
                        default: _withCtx(() => [
                          (slotDays.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createVNode(_unref(Calendar), {
                                  expanded: "",
                                  "min-date": new Date(),
                                  "max-date": maxSelectableDate.value,
                                  "disabled-dates": datePickerDisabledDates.value,
                                  attributes: calendarAttributes.value,
                                  onDayclick: onDayClick
                                }, null, 8, ["min-date", "max-date", "disabled-dates", "attributes"]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createVNode(_unref(NeueButton), {
                                    type: pendingDays.value.length ? 'secondary' : 'inactive',
                                    onClick: addDays
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Add" + _toDisplayString(pendingDays.value.length ? ` (${pendingDays.value.length})` : ''), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_45, " No fulfillment slots in the next 8 weeks. Add an active fulfillment slot for this store. "))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(FormElement), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availabilityDays(pairModal.value.pair), (day) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: day.id,
                            "data-test": "availability-day",
                            class: "rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
                          }, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_unref(CalendarDaysIcon), { class: "h-6 w-6 text-gray-600" })
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("p", _hoisted_50, _toDisplayString(formatDay(day)), 1),
                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-sm text-gray-500" }, "Fulfillment limit", -1))
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                (!pairModal.value.managed)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      "data-test": "delete-day",
                                      onClick: $event => (deleteDay(day))
                                    }, [
                                      _createVNode(_unref(XMarkIcon), { class: "cursor-pointer h-5 w-5 shrink-0 text-red-500 hover:text-red-700" })
                                    ], 8, _hoisted_52))
                                  : _createCommentVNode("", true),
                                _createVNode(_unref(NeueToggle), {
                                  modelValue: pairModal.value.hasInventoryLimit[day.id],
                                  "onUpdate:modelValue": $event => ((pairModal.value.hasInventoryLimit[day.id]) = $event),
                                  compact: "",
                                  "aria-label": "Fulfillment limit",
                                  disabled: pairModal.value.managed,
                                  onChange: savePairModal
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ])
                            ]),
                            (pairModal.value.hasInventoryLimit[day.id])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createVNode(_unref(InputField), {
                                    modelValue: pairModal.value.inventoryLimit[day.id],
                                    "onUpdate:modelValue": $event => ((pairModal.value.inventoryLimit[day.id]) = $event),
                                    name: "Fulfillment limit",
                                    prefix: "#",
                                    disabled: pairModal.value.managed,
                                    onChange: savePairModal
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormSection), { name: "Overall Product Limit" }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: pairModal.value.productHasQuantityLimit,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((pairModal.value.productHasQuantityLimit) = $event)),
                  name: "Limit overall inventory",
                  onChange: savePairModal
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (pairModal.value.productHasQuantityLimit)
              ? (_openBlock(), _createBlock(_unref(FormElement), {
                  key: 0,
                  size: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputField), {
                      modelValue: pairModal.value.productInventoryLimit,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((pairModal.value.productInventoryLimit) = $event)),
                      name: "Overall inventory limit",
                      type: "number",
                      error: 
              pairModal.value.productHasQuantityLimit &&
              (pairModal.value.productInventoryLimit == null || pairModal.value.productInventoryLimit === '')
            ,
                      onChange: savePairModal
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(FormSection), { name: "Membership pricing" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pairModal.value.membershipPrices, (price) => {
              return (_openBlock(), _createBlock(_unref(FormElement), { class: "flex flex-col gap-3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(price.name) + " ", 1),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: price.subject,
                    "onUpdate:modelValue": $event => ((price.subject) = $event),
                    name: "Subject to pricing tiers",
                    disabled: pairModal.value.managed,
                    onChange: savePairModal
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: price.available,
                    "onUpdate:modelValue": $event => ((price.available) = $event),
                    name: "Available for membership tier",
                    disabled: pairModal.value.managed,
                    onChange: savePairModal
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: price.default,
                    "onUpdate:modelValue": $event => ((price.default) = $event),
                    name: "Use default price",
                    disabled: pairModal.value.managed,
                    onChange: savePairModal
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                  (!price.default)
                    ? (_openBlock(), _createBlock(_unref(InputField), {
                        key: 0,
                        modelValue: price.price,
                        "onUpdate:modelValue": $event => ((price.price) = $event),
                        name: "Dollar amount",
                        prefix: "$",
                        disabled: pairModal.value.managed,
                        onChange: savePairModal
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "primary",
          onClick: closePairModal
        }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
            _createTextVNode("Done", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": removeModal.value.open,
      "modal-title": "Remove product from store?",
      onCloseModal: _cache[16] || (_cache[16] = $event => (removeModal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createElementVNode("p", _hoisted_54, [
          _cache[25] || (_cache[25] = _createTextVNode(" Removing ", -1)),
          _createElementVNode("span", _hoisted_55, _toDisplayString(product(removeModal.value.pair)?.product_name || 'this product'), 1),
          _cache[26] || (_cache[26] = _createTextVNode(" from this store will delete its store-specific settings (availability days, pricing, and taxable / autofill options). If you add this product back to the store later, you'll need to set those up again. ", -1))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "red",
          disabled: removeModal.value.loading,
          class: "mr-3",
          onClick: confirmRemovePair
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
            _createTextVNode("Remove", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          disabled: removeModal.value.loading,
          onClick: _cache[15] || (_cache[15] = $event => (removeModal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}